module.exports = __webpack_public_path__ + "static/media/book-cover-pink.308723b5.jpg";